import axiosInstance from "@/api/axiosInstance";
import { GetMyRegistrationsResponse } from "./types";

export const getMyRegistrations =
  async (): Promise<GetMyRegistrationsResponse> => {
    const url = "/api/private/my-registrations";
    const response = await axiosInstance.get<GetMyRegistrationsResponse>(url);

    return response.data;
  };
